import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { getOrdersRequest } from "../components/authApi";
import SeoManager from "../SeoManager";

export default function OrdersPage() {
  const { user, loading } = useAuth();
  const [orders, setOrders] = useState([]);
  const [ordersLoading, setOrdersLoading] = useState(false);

  useEffect(() => {
    if (!user) {
      setOrders([]);
      setOrdersLoading(false);
      return;
    }

    const fetchOrders = async () => {
      setOrdersLoading(true);
      try {
        const response = await getOrdersRequest();
        setOrders(response.status === "success" && Array.isArray(response.data) ? response.data : []);
      } catch (error) {
        console.error("Error fetching orders:", error);
        setOrders([]);
      } finally {
        setOrdersLoading(false);
      }
    };

    fetchOrders();
  }, [user]);

  if (loading) return <p>Loading your orders...</p>;

  if (!user) {
    return (
      <div className="content-page">
        <SeoManager
          title="My Orders"
          description="Review orders from your Asher Jewels PH customer account."
          path="/orders"
          robots="noindex,nofollow"
        />
        <section className="content-hero">
          <p className="category-section__eyebrow">Purchase Records</p>
          <h1>My Orders</h1>
          <p>Please sign in to view the orders tied to your customer account.</p>
        </section>
        <div className="content-card content-empty">
          <h2>Login required</h2>
          <p>Your order history is only available after secure sign-in.</p>
          <Link to="/login" className="content-link-button">Go to Login</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="content-page">
      <SeoManager
        title="My Orders"
        description="Review completed orders and shipping details from your Asher Jewels PH customer account."
        path="/orders"
        robots="noindex,nofollow"
      />
      <section className="content-hero">
        <p className="category-section__eyebrow">Purchase Records</p>
        <h1>My Orders</h1>
        <p>Review your completed orders and the shipping details attached to each purchase.</p>
      </section>

      <article className="content-card">
        {ordersLoading ? (
          <p>Loading orders...</p>
        ) : orders.length === 0 ? (
          <p>No completed orders found yet.</p>
        ) : (
          <div className="responsive-table">
            <table className="orders-table">
              <thead>
                <tr>
                  <th>Product</th>
                  <th>Code</th>
                  <th>Price</th>
                  <th>Status</th>
                  <th>Date</th>
                  <th>Shipping</th>
                </tr>
              </thead>
              <tbody>
                {orders.map((order) => (
                  <tr key={order.order_id}>
                    <td>{order.product_name}</td>
                    <td>{order.product_code}</td>
                    <td>?{Number(order.pricePHP).toLocaleString()}</td>
                    <td>{order.status}</td>
                    <td>{new Date(order.order_date).toLocaleString()}</td>
                    <td>
                      {order.customer_name}<br />
                      {order.address}, {order.city}, {order.postal_code}<br />
                      {order.contact_number}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </article>
    </div>
  );
}
